"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PMCActiveModules = exports.PMCLogoSections = exports.PMCSlotStatuses = exports.PMCV8SearchWidgetValidTemplateNames = exports.PMCV8SearchWidgetValidTypeaheadCategories = exports.BASE_TAB = void 0;
exports.BASE_TAB = {
    LOCATIONS: 'locations',
    NOTES: 'notes',
    INSURANCE: 'insurance',
    PRACTICE_GROUPS: 'practiceGroups',
    CLINICAL_KEYWORDS: 'clinicalKeywords',
    TRAINING: 'training',
    SCHEDULING_INSTRUCTIONS: 'schedulingInstructions'
};
// https://kyruus.jira.com/wiki/spaces/AHC/pages/2169144221/Search+API+v8+vs.+v9#Categories-Differences
// https://stg-searchservice-v8.kyruus.com/docs/#!/typeahead/typeahead
exports.PMCV8SearchWidgetValidTypeaheadCategories = [
    'name',
    'provider_name',
    'specialty',
    'specialty_strict',
    'specialty_synonym',
    'clinical_combined',
    'clinical_experience',
    'practice_group',
    'practice_location',
    'network_affiliation',
    'primary_care',
    'primary_care_condition'
];
exports.PMCV8SearchWidgetValidTemplateNames = [
    'defaultPMC',
    'broadwayHealthDemo',
    'baptist'
];
var PMCSlotStatuses;
(function (PMCSlotStatuses) {
    PMCSlotStatuses["LOADING"] = "@slots/loading";
    PMCSlotStatuses["SUCCESS"] = "@slots/success";
    PMCSlotStatuses["ERROR"] = "@slots/error";
})(PMCSlotStatuses = exports.PMCSlotStatuses || (exports.PMCSlotStatuses = {}));
var PMCLogoSections;
(function (PMCLogoSections) {
    PMCLogoSections["SEARCH"] = "@logo/search";
    PMCLogoSections["PROFILE"] = "@logo/profile";
})(PMCLogoSections = exports.PMCLogoSections || (exports.PMCLogoSections = {}));
exports.PMCActiveModules = {
    SEARCH_MATCH: 'search_match',
    DIRECT_BOOK: 'direct_book',
    LOCATIONS: 'locations',
    MAP_SEARCH: 'map_search',
    AUTHENTICATION: 'authentication',
    PROFILE: 'profile',
    CRM_INTEGRATION: 'crm_integration',
    VISIBILITY_AGENT: 'visibility_agent',
    REFERRAL: 'referral'
};
//# sourceMappingURL=types.js.map